import { Component, inject } from '@angular/core'
import { FormGroup } from '@angular/forms'

import { Profile } from '@cyborg-monorepo/hunter/common'
import { DialogRef, DIALOG_DATA } from '@hyperkit'

import { UserService } from '../../../../shared/services/user.service'

@Component({
  standalone: false,
  selector: 'delete-user-dialog',
  templateUrl: './delete-user-dialog.component.html',
  styleUrls: ['./delete-user-dialog.component.scss'],
})
export class DeleteUserDialogComponent {
  dialogRef = inject(DialogRef)
  private userService = inject(UserService)
  user = inject<Profile>(DIALOG_DATA, { optional: true })

  public formGroup: FormGroup
  public roles: Array<string> = []
  public error: string

  public onDelete(): void {
    this.userService.deleteUser(this.user.id).subscribe(
      () => {
        this.dialogRef.close()
      },
      (error) => {
        this.error = error.message
      },
    )
  }

  public onClose(): void {
    this.dialogRef.close()
  }
}
